import { render } from "./raceSignInfo.vue?vue&type=template&id=1aa6088c&scoped=true"
import script from "./raceSignInfo.vue?vue&type=script&lang=js"
export * from "./raceSignInfo.vue?vue&type=script&lang=js"

import "./raceSignInfo.vue?vue&type=style&index=0&id=1aa6088c&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa6088c"]])

export default __exports__